import * as d3 from 'd3'
export default {

  methods: {

    gauge_Actual() {

      // Gauge - Actual
      let angle = this.angle
      let circle = this.circle

      let stAngle = ''
      let proAn = (180/100) * this.rawData.A_PRO
    
      var arc = d3.arc()
      .innerRadius(circle.radius)
      .outerRadius(circle.radius - circle.tickness)
      .startAngle(()=> stAngle || 270 * Math.PI / 180)
      .endAngle(() => angle.end * Math.PI / 180)

      let gauge = this.canvasForms
      .append('g')
      .attr('transform', `translate(${this.circle.cx},${this.circle.cy})`)

      gauge
      .append('path')
      .attr('transform', `translate(0, 0)`)
      .attr('d', arc).attr('fill', `#E0E0DF`).attr('opacity', 1)
      .transition().duration(500)
      .attrTween('d', ()=> {
        let stAngle_ = (270 * Math.PI / 180)
        let interpolate = d3.interpolate(stAngle_, (270+proAn) * Math.PI / 180)
        return function(t) {
          stAngle = interpolate(t)
          return arc()
        }
      })


      // Actual Cumulative Progress
      gauge
      .append('text')
      .attr('transform', `translate(0, ${this.title.total.tSize*0.36})`)
      .attr('font-size', this.title.total.tSize).attr('fill', this.title.total.tColor)
      .attr('text-anchor', this.title.total.align)
      .text(this.title.total.name)

      let col = null
      let act = gauge
      .append('g')
      .attr('id', `TOTAL_ACTUAL_${this.localId}`)
      .attr('transform', `translate(0, 0)`)

      col = this.columns.find(f=> f.code == 'TOTAL')
      act
      .append('text')
      .attr('id', `TOT_${this.localId}`)
      .attr('x', 0).attr('y', -10)
      .attr('font-size', col.tSize).attr('fill', col.tColor)
      .text(this.rawData[col.code] + '/')
      .call(this.event_Link, col) // -----> event_Link

      // console.log(col)

      col = this.columns.find(f=> f.code == 'A_QTY')
      act
      .append('text')
      .attr('id', `ACT_${this.localId}`)
      .attr('x', this.getNode(`#TOT_${this.localId}`)+2).attr('y', -10)
      .attr('font-size', col.tSize).attr('fill', col.tColor)
      .text(this.rawData[col.code])
      .call(this.event_Link, col) // -----> event_Link

      d3.select(`#TOTAL_ACTUAL_${this.localId}`)
      .attr('transform', `translate(${-(this.getNode(`#TOTAL_ACTUAL_${this.localId}`, 'width')/2)}, 0)`)
    },

  }
}